import {useEffect} from 'react'
import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../../routes/routes'

const ProductsSectionHeader = () => {

  const changeSubmenuStyleBasedOnScroll = ()=> {
    const header = document.querySelector('#header')
    const subMenu = document.querySelector('.nav-header')

    if (window.innerWidth > 990) {
      const currentScrollPos = window.scrollY

      if (currentScrollPos> 90) {
        header.classList.add('hidden')
        subMenu.classList.add('fixed')
      } else {
        header.classList.remove('hidden')
        subMenu.classList.remove('fixed')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeSubmenuStyleBasedOnScroll)

    return () => window.removeEventListener('scroll', changeSubmenuStyleBasedOnScroll)
  }, [])

  const links = [
    {id: 'products-brands', label: 'Overview'},
    {id: 'products-our-products', label: 'Our products'},
    {id: 'products-countries', label: 'Geographical reach'}
  ]

  return (
    <div className="nav-header">
      <div className="nav-header-container">
        <ul>
          {links.map(({id, label}) => {
            return (
              <li key={`products-sub-menu-${id}`}>
                <HashLink to={`${APP_ROUTES.PRODUCTS}#${id}`}>{label}</HashLink>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default ProductsSectionHeader
